import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Entities } from '../../../../core/models/globals';
import { NavigationService } from '../../../../core/services/navigation.service';

@Component({
  selector: 'app-session-left-panel',
  templateUrl: './session-left-panel.component.html',
  styleUrls: ['./session-left-panel.component.scss']
})
export class SessionLeftPanelComponent implements OnInit {

  properties = [
    {
      name: 'Sessions',
      routerLink: 'Sessions',
      spanClass: 'bi bi-pc-display-horizontal',
    },
    {
      name: 'Processes',
      routerLink: 'Processes',
      spanClass: 'bi bi-window-stack',
    },
    {
      name: 'Logs',
      routerLink: 'Logs',
      spanClass: 'bi bi-body-text',
    },
  ];

  selectedIndex: number = 0;

  constructor(private navService: NavigationService, private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.navService.sendParentData(Entities.Sessions);
    this.navService.index.subscribe((x) => (this.selectedIndex = x));
  }

  sendData(index: number, property) {
    if (this.selectedIndex != index) {
      this.selectedIndex = index;
      this.navService.sendParentData(property.name);
      this.navService.sendLeftPanelIndex(index);
      this.router.navigate([property.routerLink], { relativeTo: this.route })
      this.navService.selectedLogType = "Session";
    }
  }

}
